import { Budget } from "@interfaces/budget-response";
import { Certificate } from "@interfaces/certificate";
import { NfCompany } from "@interfaces/company-nf";
import { PNCompany } from "@interfaces/pn-company";
import { Usage } from "@interfaces/usage";
import { createFeature, createReducer, on } from "@ngrx/store";
import { UserActions } from "@state/actions/user.actions";

export const userFeatureKey = "user";

export interface State {
  token: string;
  company: {
    nf: NfCompany | null;
    pn: PNCompany | null;
    certificate: Certificate | null;
    usage: Usage | null;
  };
  budgets: {
    [page: number]: Budget[];
  };
  issuesEnabled: boolean;
}

export const initialState: State = {
  token: "",
  company: {
    nf: null,
    pn: null,
    certificate: null,
    usage: null
  },
  budgets: {},
  issuesEnabled: false
};

export const reducer = createReducer(
  initialState,
  on(
    UserActions.loadToken,
    (state, { token }): State => ({
      ...state,
      token
    })
  ),
  on(
    UserActions.loadNFCompany,
    (state, { company }): State => ({
      ...state,
      company: {
        ...state.company,
        nf: company
      }
    })
  ),
  on(
    UserActions.loadPNCompany,
    (state, { company }): State => ({
      ...state,
      company: {
        ...state.company,
        pn: company
      }
    })
  ),
  on(
    UserActions.loadCertificate,
    (state, { certificate }): State => ({
      ...state,
      company: {
        ...state.company,
        certificate
      }
    })
  ),
  on(
    UserActions.loadBudgets,
    (state, { page, budgets }): State => ({
      ...state,
      budgets: {
        ...state.budgets,
        [page]: budgets
      }
    })
  ),
  on(
    UserActions.loadLimits,
    (state, { limits }): State => ({
      ...state,
      company: {
        ...state.company,
        usage: limits
      }
    })
  )
);

export const userFeature = createFeature({
  name: userFeatureKey,
  reducer
});
